<div class="uk-section uk-section-small uk-padding-remove-top">
  <div class="uk-container uk-container-expand">

    @if (loading) {
      <div class="uk-flex uk-flex-center uk-margin-medium-top">
        <span data-uk-spinner="ratio: 2"></span>
      </div>

    } @else if (latestAnswerInfo) {
      <div class="uk-margin-medium-bottom">
        <h4 class="uk-text uk-margin-remove-bottom">Welcome to the Survey Tool of the EOSC Open Science Observatory</h4>
        <p class="uk-text-meta uk-margin-top">
          This survey tool was originally developed within the EOSC Future project and is now further enhanced by the
          EOSC Track project to support the monitoring activities of the EOSC Steering Board. The tool is used to
          conduct the Survey on National Contributions to EOSC and Open Science, which collects information
          from representatives of European Member States and Associated Countries. All current and past surveys,
          together with submitted responses, will be available to authorised users through this survey tool.
        </p>
      </div>
      <div class="uk-grid uk-grid-medium uk-child-width-1-3@m uk-grid-match" data-uk-grid>

        <div>
          <div class="uk-card uk-card-default uk-card-body uk-border-rounded">
            <div class="uk-flex uk-flex-between uk-flex-top">
              <div>
                <h6 class="uk-text-meta uk-margin-remove uk-text-uppercase"
                    style="font-size: 0.75rem; letter-spacing: 1px;">
                  Completion Rate
                </h6>

                <h2 class="uk-margin-small-top uk-margin-remove-bottom uk-text-bold"
                    style="color: #1a2b4e; font-size: 1.6rem;">
                  {{ (latestAnswerInfo.progressTotal.current / latestAnswerInfo.progressTotal.total) | percent:'1.0-0' }}
                </h2>
              </div>

              <div class="uk-flex uk-flex-center uk-flex-middle uk-border-rounded"
                   style="width: 42px; height: 42px; background-color: #2ecc71; color: white;">
                <span class="material-symbols-outlined" style="font-size: 24px;">moving</span>
              </div>
            </div>

            <div class="uk-margin-small-top">
              <progress class="uk-progress uk-margin-remove-bottom"
                        [value]="latestAnswerInfo.progressTotal.current"
                        [max]="latestAnswerInfo.progressTotal.total"
                        style="height: 6px; border-radius: 4px;">
              </progress>
              <p class="uk-text-meta uk-text-right uk-margin-remove-top uk-text-small">
                {{ latestAnswerInfo.progressTotal.current }} / {{ latestAnswerInfo.progressTotal.total }} Questions
              </p>
            </div>
          </div>
        </div>

        <div>
          <div class="uk-card uk-card-default uk-card-body uk-border-rounded">
            <div class="uk-flex uk-flex-between uk-flex-top">
              <div>
                <h6 class="uk-text-meta uk-margin-remove uk-text-uppercase" style="font-size: 0.75rem;">
                  Deadline
                </h6>

                <h2 class="uk-margin-small-top uk-margin-remove-bottom uk-text-bold"
                    style="color: #1a2b4e; font-size: 1.6rem;">
                  {{ latestAnswerInfo.submissionCloseAt | date:'dd.MM.yy' }}
                </h2>
              </div>

              <div class="uk-flex uk-flex-center uk-flex-middle uk-border-rounded"
                   style="width: 42px; height: 42px; background-color: #3498db; color: white;">
                <span class="material-symbols-outlined" style="font-size: 24px;">calendar_today</span>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="uk-card uk-card-default uk-card-body uk-border-rounded">
            <div class="uk-flex uk-flex-between uk-flex-top">
              <div>
                <h6 class="uk-text-meta uk-margin-remove uk-text-uppercase" style="font-size: 0.75rem;">
                  Validated
                </h6>

                <h2 class="uk-margin-small-top uk-margin-remove-bottom uk-text-bold"
                    style="color: #1a2b4e; font-size: 1.6rem;">
                  {{ latestAnswerInfo.validated ? 'Yes' : 'No' }}
                </h2>
              </div>

              <div class="uk-flex uk-flex-center uk-flex-middle uk-border-rounded"
                   style="width: 42px; height: 42px; background-color: #051650; color: white;">
                <span class="material-symbols-outlined">beenhere</span>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="uk-margin-medium-top">
        <h5 class="uk-text-bold uk-margin-small-bottom">
          Quick Actions
        </h5>

        <div class="uk-grid uk-grid-medium uk-child-width-1-2@m uk-grid-match" uk-grid>
          <div>
            <div class="uk-card uk-card-default uk-card-body uk-border-rounded uk-card-hover" style="cursor: pointer;"
                 (click)="navigateToMySurveys()">

              <div class="uk-flex uk-flex-middle">

                <div class="uk-flex uk-flex-center uk-flex-middle uk-border-rounded uk-margin-right"
                     style="width: 48px; height: 48px; background-color: #e0f7fa; color: #006064; flex-shrink: 0;">
                  <span class="material-symbols-outlined" style="font-size: 28px;">description</span>
                </div>

                <div class="uk-width-expand">
                  <h4 class="uk-margin-remove uk-text-bold" style="color: #1a2b4e; font-size: 1.1rem;">
                    Continue Survey
                  </h4>
                  <p class="uk-text-meta uk-margin-remove-top uk-text-small">
                    Resume filling the Survey on National Contributions to EOSC and Open Science
                  </p>
                </div>

                <div class="uk-flex uk-flex-middle" style="color: #95a5a6;">
                  <span class="material-symbols-outlined">
                    arrow_forward
                  </span>
                </div>

              </div>
            </div>
          </div>

          <div>
            <div class="uk-card uk-card-default uk-card-body uk-border-rounded uk-card-hover"
                 style="cursor: not-allowed;" data-uk-tooltip="title: Coming soon...">

              <div class="uk-flex uk-flex-middle">

                <div class="uk-flex uk-flex-center uk-flex-middle uk-border-rounded uk-margin-right"
                     style="width: 48px; height: 48px; background-color: #e6fae1; color: #2ecc71; flex-shrink: 0;">
                  <span class="material-symbols-outlined">
                    upload
                  </span>
                </div>

                <div class="uk-width-expand">
                  <h4 class="uk-margin-remove uk-text-bold" style="color: #1a2b4e; font-size: 1.1rem;">
                    Upload News Item
                  </h4>
                  <p class="uk-text-meta uk-margin-remove-top uk-text-small">
                    Propose news, blogs and other information for the EOSC Open Science Observatory News
                  </p>
                </div>

                <div class="uk-flex uk-flex-middle" style="color: #95a5a6;">
                  <span class="material-symbols-outlined">
                    arrow_forward
                  </span>
                </div>

              </div>
            </div>
          </div>

          <div>
            <div class="uk-card uk-card-default uk-card-body uk-border-rounded uk-card-hover"
                 style="cursor: not-allowed;" uk-tooltip="title: Coming soon...">

              <div class="uk-flex uk-flex-middle">

                <div class="uk-flex uk-flex-center uk-flex-middle uk-border-rounded uk-margin-right"
                     style="width: 48px; height: 48px; background-color: #fae1e9; color: #fa558c; flex-shrink: 0;">
                  <span class="material-symbols-outlined">
                      download
                  </span>
                </div>

                <div class="uk-width-expand">
                  <h4 class="uk-margin-remove uk-text-bold" style="color: #1a2b4e; font-size: 1.1rem;">
                    Export Data
                  </h4>
                  <p class="uk-text-meta uk-margin-remove-top uk-text-small">
                    Download your current progress and submitted data in various formats.
                  </p>
                </div>

                <div class="uk-flex uk-flex-middle" style="color: #95a5a6;">
                  <span class="material-symbols-outlined">
                      arrow_forward
                  </span>
                </div>

              </div>
            </div>
          </div>

          <div>
            <div class="uk-card uk-card-default uk-card-body uk-border-rounded uk-card-hover"
                 style="cursor: pointer" (click)="navigateToSupportPage()">

              <div class="uk-flex uk-flex-middle">

                <div class="uk-flex uk-flex-center uk-flex-middle uk-border-rounded uk-margin-right"
                     style="width: 48px; height: 48px; background-color: #e9e8eb; color: #312a5e; flex-shrink: 0;">
              <span class="material-symbols-outlined">
                  calendar_today
              </span>
                </div>

                <div class="uk-width-expand">
                  <h4 class="uk-margin-remove uk-text-bold" style="color: #1a2b4e; font-size: 1.1rem;">
                    Support
                  </h4>
                  <p class="uk-text-meta uk-margin-remove-top uk-text-small">
                    Checkout out tutorials and guides. Get in touch with the EOSC Track team for assistance.
                  </p>
                </div>

                <div class="uk-flex uk-flex-middle" style="color: #95a5a6;">
                  <span class="material-symbols-outlined">
                      arrow_forward
                  </span>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-margin-medium-top">
        <h5 class="uk-text-bold uk-margin-small-bottom">Analytics & Insights</h5>

        <div class="uk-grid uk-grid-medium uk-child-width-1-2@m uk-grid-match" uk-grid>

          <div>
            <div class="uk-card uk-card-default uk-card-body uk-border-rounded">
              <div class="uk-flex uk-flex-between uk-flex-middle uk-margin-small-bottom">
                <h4 class="uk-card-title uk-margin-remove uk-text-bold">
                  Views on Country Pages per Month
                </h4>
              </div>

              <div class="uk-margin-top" style="min-height: 400px;">
                @if (viewSeries.length > 0) {
                  <app-stacked-column
                    [series]="viewSeries"
                    [categories]="viewCategories"
                    [title]="''"
                    [yAxis]="'Views'"
                    [stacking]="'normal'"
                    [stackLabels]="false"
                    [dataLabels]="false"
                    [pointFormat]="tooltipPointFormat"
                    [height]="400">
                  </app-stacked-column>

                  <div class="uk-flex uk-flex-between uk-flex-middle uk-margin-top uk-padding-small uk-border-rounded">
                    <span class="uk-text-muted">
                      Total views for the last {{ viewCategories.length }} months
                    </span>
                    <span class="uk-text-bold">
                      {{ totalViews | number }}
                    </span>
                  </div>
                } @else {
                  <div class="uk-flex uk-flex-center uk-flex-middle" style="height: 400px;">
                    <span data-uk-spinner="ratio: 1.5"></span>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="uk-visible@m"></div>

          <div>
            <div class="uk-card uk-card-default uk-card-body uk-border-rounded">
              <div class="uk-flex uk-flex-between uk-flex-middle uk-margin-small-bottom">
                <h4 class="uk-card-title uk-text-bold uk-margin-remove">Recent Actions</h4>
                <a (click)="navigateToHistory()" class="uk-link-reset uk-flex uk-flex-middle uk-text-muted"
                   style="cursor: pointer;">
                  <span class="uk-text-small uk-margin-small-right">View All</span>
                  <span class="material-symbols-outlined">arrow_forward</span>
                </a>
              </div>

              <hr class="uk-margin-small-top uk-margin-small-bottom">

              <div class="uk-margin-small-top">
                @if (loading) {
                  <div class="uk-text-center uk-padding-small">
                    <div uk-spinner="ratio: 0.8"></div>
                  </div>
                } @else {
                  @for (entry of recentHistory; track entry.time) {
                    <div class="uk-padding-small uk-padding-remove-horizontal uk-flex uk-flex-top">
                      <span class="material-symbols-outlined uk-margin-small-right">
                        edit_note
                      </span>
                      <div class="uk-width-expand">
                        <p class="uk-margin-remove">
                          Updated on: {{ entry.time | date:'dd/MM/yy' }}
                        </p>
                        <p class="uk-margin-remove uk-text-small uk-text-bold uk-text-truncate">
                          {{ entry.editors[0]?.fullname }} ({{ entry.editors[0]?.role }})
                        </p>
                        <p class="uk-margin-remove uk-text-small uk-text-muted uk-text-italic">
                          {{ (entry.comment && entry.comment !== "") ? entry.comment : 'No comment provided' }}
                        </p>
                      </div>
                    </div>
                    <hr>
                  } @empty {
                    <div class="uk-padding-small uk-text-center uk-text-meta">No recent actions found.</div>
                  }
                }
              </div>
            </div>
          </div>

          <div>
            <div class="uk-card uk-card-default uk-card-body uk-border-rounded">
              <div class="uk-flex uk-flex-between uk-flex-middle uk-margin-small-bottom">
                <h4 class="uk-card-title uk-text-bold uk-margin-remove">Recent Messages</h4>
                <a (click)="navigateToMessages()" class="uk-link-reset uk-flex uk-flex-middle uk-text-muted"
                   style="cursor: pointer;">
                  <span class="uk-text-small uk-margin-small-right">View All</span>
                  <span class="material-symbols-outlined">arrow_forward</span>
                </a>
              </div>

              <hr class="uk-margin-small-top uk-margin-small-bottom">

              <div class="uk-margin-small-top">
                @if (loadingThreads) {
                  <div class="uk-text-center uk-padding-small">
                    <div uk-spinner="ratio: 0.8"></div>
                  </div>
                } @else {
                  @for (thread of recentThreads; track thread.id) {
                    <div class="uk-padding-small uk-padding-remove-horizontal uk-flex uk-flex-top">
                      <span class="material-symbols-outlined uk-margin-small-right">
                        forum
                      </span>
                      <div class="uk-width-expand">
                        <p class="uk-margin-remove uk-text-small uk-text-bold uk-text-truncate">
                          {{ thread.subject }}
                        </p>
                        <p class="uk-margin-remove uk-text-small uk-text-muted uk-text-italic uk-text-truncate">
                          {{ stripHtml($safeNavigationMigration(thread.messages[thread.messages.length - 1]?.body)) }}
                        </p>
                      </div>
                    </div>
                    <hr>
                  } @empty {
                    <div class="uk-padding-small uk-text-center uk-text-meta">No recent messages found.</div>
                  }
                }
              </div>
            </div>
          </div>

        </div>
      </div>
    } @else {
      <div class="uk-alert uk-alert-primary">
        <p>No active surveys found.</p>
      </div>
    }
  </div>
</div>
